import React from 'react';
import AlertBar from '../common/AlertBar';

const AdBlockerAlert = () => (
  <AlertBar alertType="warning">
    <strong>Ad Blocker Detected.</strong> Please disable any ad blocking software as it interferes with our ad creation system.
  </AlertBar>
);

export default AdBlockerAlert;



// WEBPACK FOOTER //
// ./src/components/Alerts/AdBlockerAlert.js